<template>
  <div class="Coco">
    <div class="title">{{title}}</div>
    <div v-if="user.coco_id">已绑定CodeCombat账号</div>
    <div class="panel" v-else>
      <p>1. 如果你已经在扣哒世界 koudashijie.com上有学习账号，你可以点击"去绑定"，然后在弹出的窗口中"登录"你的账号继续你的学习记录（即比赛闯关不需要从第一关开始）。<br>
        2. 如果你没有使用过CodeCombat教学平台，请点击“跳过”。<br>
        3. 如果不确定是否有账号，请询问你的家长或老师</p>
      <div class="button">
        <my_button :value="'去绑定'" :inputStyle="buttonStyle" @click.native="auth"></my_button>
        <my_button :value="'跳过'" :inputStyle="buttonStyle" @click.native="prompt"></my_button>
      </div>
    </div>
    <div class="prompt fs20" v-if="prpt">
      <div class="content">
        跳过绑定，我们将为你自动创建新的CodeCombat账号
      </div>
      <div class="button">
        <my_button :value="'确认'" :inputStyle="buttonStyle" @click.native="register"></my_button>
        <my_button :value="'取消'" :inputStyle="buttonStyle" @click.native="cancel"></my_button>
      </div>
    </div>
  </div>
</template>

<script>
  import MyButton from '@/components/Button.vue'

  export default {
    name: 'Coco',
    props: {},
    data() {
      return {
        prpt: false
      }
    },
    computed: {
      title() {
        return '绑定账号'
      },
      user() {
        return this.$store.state.auth.user
      },
      buttonStyle() {
        return {
          'background-color': '#F8E900',
          'font-size': '0.9375vw',
          'color': '#241171',
          'height': '1.979vw',
          'margin': '0 1vw',
          'width': '7vw',
          'border-radius': '3px'
        }
      }
    },
    methods: {
      auth() {
        let routeData = this.$router.resolve({name: 'Jump'})
        let child = window.open(routeData.href, '_blank', 'width=1000,height=800')
        let that = this
        let loop = setInterval(function () {
          if (child.closed) {
            clearInterval(loop)
            that.$http.get('/api/login/me')
              .then(res => {
                that.$store.commit('SET_USER', res.data)
              })
          }
        })
      },
      prompt() {
        this.prpt = true
      },
      cancel() {
        this.prpt = false
      },
      register() {
        this.$http.post('/api/codecombat/bind/new')
          .then(res => {
            this.$store.commit('SET_USER', res.data.user)
            this.prpt = false
          })
          .catch(err => {
            alert(err.response.data.message)
          })
      }
    },
    components: {
      my_button: MyButton
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Coco{
    width: 62.5vw;
    background-image: url(~@/assets/image/enroll/bg-area.png);
    background-size: 62.5vw;
    box-sizing: border-box;
    color: white;
    font-weight: 500;
    border-radius: 2px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 2.4vw 3.8vw 2.1vw;
  }

  .title{
    color: white;
    font-size: 1.875vw;
    line-height: 1.85vw;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2vw;
  }

  .panel{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .button{
    display: flex;
  }

  .prompt{
    position: absolute;
    width: 50vw;
    border-radius: 1vw;
    border: 1vw solid #3621dd;
    height: 13vw;
    background: #402af2;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
  }
</style>
